import { useState } from 'react';

interface HeaderProps {
  cartCount: number;
  onCartClick: () => void;
}

export default function Header({ cartCount, onCartClick }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/5491155857757?text=Hola! Me interesa conocer más sobre sus productos de Perra Luxury', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-800">
      {/* Promotional banner */}
      <div className="bg-gradient-to-r from-[#C6A45C] to-[#B8954F] text-black text-center py-2 text-sm font-light" style={{ fontFamily: '"Lato", sans-serif' }}>
        <div className="animate-pulse">
          ✨ Envío gratis en compras superiores a USD 300 ✨
        </div>
      </div>
      
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo - Ajustado para encajar perfectamente en el header */}
          <div className="flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/14bc07072b1222d7eb46239cc0c33b30/d8b98b2f768863edbee6ca61c469a3bc.jpeg"
              alt="Perra Luxury"
              className="h-16 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity duration-300"
              onClick={scrollToTop}
            />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a 
              href="#carteras" 
              className="text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Carteras
            </a>
            <a 
              href="#accesorios" 
              className="text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Accesorios
            </a>
            <a 
              href="#sobre-nosotros" 
              className="text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Sobre Nosotros
            </a>
            <a 
              href="#contacto" 
              className="text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Contacto
            </a>
          </nav>

          {/* Right side icons */}
          <div className="flex items-center space-x-4">
            <button className="text-white hover:text-[#C6A45C] transition-all duration-300 transform hover:scale-110">
              <i className="ri-search-line text-xl"></i>
            </button>
            
            {/* WhatsApp button */}
            <button 
              onClick={openWhatsApp}
              className="text-white hover:text-[#25D366] transition-all duration-300 transform hover:scale-110"
              title="Contactar por WhatsApp"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </button>
            
            <button 
              onClick={onCartClick}
              className="relative text-white hover:text-[#C6A45C] transition-all duration-300 transform hover:scale-110"
            >
              <i className="ri-shopping-cart-line text-xl"></i>
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#C6A45C] text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
                  {cartCount}
                </span>
              )}
            </button>
            
            {/* Mobile menu button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-white hover:text-[#C6A45C] transition-colors duration-300"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-sm border-t border-gray-800 py-4">
            <nav className="flex flex-col space-y-4">
              <a 
                href="#carteras" 
                className="block px-3 py-2 text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
                style={{ fontFamily: '"Lato", sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Carteras
              </a>
              <a 
                href="#accesorios" 
                className="block px-3 py-2 text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
                style={{ fontFamily: '"Lato", sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Accesorios
              </a>
              <a 
                href="#sobre-nosotros" 
                className="block px-3 py-2 text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
                style={{ fontFamily: '"Lato", sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Sobre Nosotros
              </a>
              <a 
                href="#contacto" 
                className="block px-3 py-2 text-white hover:text-[#C6A45C] transition-colors duration-300 font-thin"
                style={{ fontFamily: '"Lato", sans-serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Contacto
              </a>
              <button 
                onClick={openWhatsApp}
                className="text-left text-white hover:text-[#25D366] transition-colors duration-300 font-thin text-sm uppercase tracking-wider flex items-center" 
                style={{ fontFamily: '"Lato", sans-serif' }}
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
